type Obj = {
  [key:string]:string[]
}
const obj:Obj = {
  '👌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F83e153eaad_euZfn3C9Dt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6cbdad831c_RfZqUYm4nc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F18af2bf1ee_GEEQtLSrsY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F40388d0c9d_V96iPd572p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F78e59c3439_iFbdBbFlbA.gif',
  ],
  '🤣': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c61b17e3a_kiHOWBylhC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff372755d6e_dSBXaA72bM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb9b4baed49_mqbTEZqoDn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9985c8d1e4_71qy5SyUyG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbddd5c1649_lXWERC0s3g.gif',
  ],
  '❌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F640182e58a_KqrroHvrnl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fad22ce33bd_fnEgjDsuwT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa07e03a314_UHNRnDPYR5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62d334b7d8_m0Mu7xN3Eq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd62f82ea35_iDRIeG0WMM.gif',
  ],
  '😆': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F656f9076f6_DmlU1vcl9M.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F65513b2fc3_T69GxszTRM.gif',
    'https://img-i.mojitok.com/emoticons/w300/dde1d028a5_f5JUSsIt3w.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febc1ccd88c_36HldhngVQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf2132f381_0WtLImmmbi.gif',
  ],
  '👍': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fadb51eda06_kZrv0YAV15.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6747b90346_1ShLyUGMoq.gif',
    'https://img-i.mojitok.com/emoticons/w300/8d120ffa34_ygKSbd75Mo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2662dc055a_Wh4FwVo0J1.gif',
    'https://img-i.mojitok.com/emoticons/w300/931dc886e6_QB3ph8oyff.gif',
  ],
  '❓': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcc1a0ec738_EiwfH1MiiC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd156ffea6e_pr1lEoDi84.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff72de9864c_GRFyjexQfq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc5a7a148d3_pCz0TafCn8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F72df790442_vN2TLx6yJm.gif',
  ],
  '👋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff4c1c5d3d0_VvEnxDcBic.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F33a3ada74d_QDv4qjboGj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc4a7e21cac_npEs2bOctq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf2132f381_0WtLImmmbi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2529140025_MOM3v597ps.gif',
  ],
  '🙏': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff2752f82cc_cgd7v2KXXL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9ea7058953_ncPEl5IHEY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F76cb305bed_sTOmHsjoNA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe0365ef24a_SLtInbDbiU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F655f3fcd45_3XUJhfCIF0.gif',
  ],
  '😍': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0bbe5dbf71_XzuUE4GPuP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F42a3fc740e_Ol8Qm2X0xD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff610b6f745_RZsJenCE94.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8dfa3f4b29_2ugSUzhp9O.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fccb6279eb6_ur0yJBLP7n.gif',
  ],
  '😊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa4ec6ee824_aB1mzFfc9S.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9131d64d9c_sv59NtPGTM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf769635b8_FsjGBZztlM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F266164abb7_4OC505gnSM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fafb3c9465d_hOdADaZlph.gif',
  ],
  '😢': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4a4c0c26ed_v2G8H3JtTo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb27765865d_MFvlUku7VD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb16c9be319_oemFtgEODT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d6cd6af0a_w0RabAn6nV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3040d072fe_ANfgzFlngj.gif',
  ],
  '😱': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feec219c90f_aGvaOBIx8E.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c64399f33_4fqh3W0icb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F509ad1787f_7Gl0dXGwkw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F60b14dc38f_WBmKYwx0Vv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F106a06b7fe_571aJZcImz.gif',
  ],
  '🤩': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F355f734620_Fd0semJVmd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa96215810f_zqM1FgXeFK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3eb688c31c_KSVT8wLJGs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F48c4b9205c_u4OhMDiWnk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8940825dfc_8VbDS2qSdq.gif',
  ],
  '😅': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa1c4c1234c_8fXM4t62Iv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff3246dd61_TciKw64s9N.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F509ad1787f_7Gl0dXGwkw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F05404765b0_fxciJvo3fQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fea32896153_tkFgnXrAv0.gif',
  ],
  '🙇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc244fb72f3_S6bNtDNc6h.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1cf6555332_fDMoaPr7pA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F76cb305bed_sTOmHsjoNA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcfbeedefea_3853an5E9s.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79880e8cb5_lESSCym5XJ.gif',
  ],
  '😡': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff9171b1d63_Vff6FLyra5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbd10e7fc82_DMZzOcOaFm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fed487ca02c_ms35zxqjC6.gif',
    'https://img-i.mojitok.com/emoticons/w300/cb5f87d8ba_DZdPYhwIMG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fce073b3267_rLVGEuKeXV.gif',
  ],
  '☺': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0e8f24f2ff_LVOOptbn0U.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8644047a5b_kHJ8LNSo7b.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fba04883ff9_WLythbLTYu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbb37a8d9cb_EiObLEf0D1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe299503d26_axidN2mJ9P.gif',
  ],
  '😪': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9bd1352333_0FSt3uLDwv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3b1745b58d_UJeAo9GaKM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdb1a5f481b_mv7DnDzbJ4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3fc9bac879_BOud2uRS0i.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8fea91385f_gJAitg7eQm.gif',
  ],
  '🤤': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6ed7049993_GXIJ2t6O2Y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F67e078ed58_Qd4D7REHp2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa91fb8aa90_gQrPv8Cs2u.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F979c3fe842_FXmB7BFKOC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc73e447698_BJcJV4Er6I.gif',
  ],
  '🎂': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8983cc9a88_VKYhjYahXO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F53b7e07713_CZUt2E2EV3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febc1ccd88c_36HldhngVQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2ed1680d58_vdKz3C3p1W.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F928acc67d2_7hVcLy4Okm.gif',
  ],
  '❤': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6983cb8a43_zGQIBSkbqm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9455e7edb8_eTvkUSvGZV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff610b6f745_RZsJenCE94.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f7d391d84_56bEDo0HUT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fccb6279eb6_ur0yJBLP7n.gif',
  ],
  '🐱': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8bf7aec1bc_xEtEAKwVx8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb66eef3eef_sk74j7CsTj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F481eab710b_8lxwLTw7wJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F431550ab86_HUZnQTfZLL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb0e6298f48_1Q4iUVJHIM.gif',
  ],
  '😲': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbe6a2937fc_5KIAVJL3uC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff899f1bd9d_zPpHPMszFr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3eb688c31c_KSVT8wLJGs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F05404765b0_fxciJvo3fQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F60b14dc38f_WBmKYwx0Vv.gif',
  ],
  '🥳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcb2c4e19a4_0ckYIICNMB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F921ba22a97_IKOoPLR8zc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febc1ccd88c_36HldhngVQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0ed5127c39_ToF19RRHKI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2ed1680d58_vdKz3C3p1W.gif',
  ],
  '🐶': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7a36570626_bqYtt66Wap.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa690475fff_u2H9brT7aA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F266164abb7_4OC505gnSM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd317efcb75_EcRjJGQ4rL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe49b6ab56a_WBz9F7oGni.gif',
  ],
  '🤗': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8357447558_fBWbeC6mLI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9ba306a181_70MHyy4Mdz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F01f38cba4d_mXxKf0fP2p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3e6f82daa5_wO8SiS7C0m.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc855a1d3ad_anuns2DKBQ.gif',
  ],
  '🍽': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5b30254d66_aDoYVdOR2G.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F78c7763e3c_RhlEHAM0TT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb0e6298f48_1Q4iUVJHIM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd46544a94c_O5L4zR5Lm4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1a3b6568fa_GA7jaRqLDC.gif',
  ],
  '😴': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc5e48284fa_kjcK1K0jVJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F330166e1cd_qkggogTzUR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8fea91385f_gJAitg7eQm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79719b74a3_kTakYVDgex.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2dc166682a_DfriytWqRu.gif',
  ],
  '🐰': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F95ae846641_atzpaQyThp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbef329fbf7_ELW4qn1tKs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F166bd765e7_6M370GWJLV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa9e31a85e9_oleHZsZGlX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F447c5e3778_rm7YU1HH0B.gif',
  ],
  '🖐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5d818d51db_4nwQFqpOkS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdf523d7547_pBXzxl9PKB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc4a7e21cac_npEs2bOctq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F988064ed67_Djqq0NOV7z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F89727a6771_HPW2jlxdn9.gif',
  ],
  '😰': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F02bcf0a94d_FCq9azatrn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79880e8cb5_lESSCym5XJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F10038d7011_NPliRMqLah.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F509ad1787f_7Gl0dXGwkw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff3246dd61_TciKw64s9N.gif',
  ],
  '🎅': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fec9819e1ce_59TCiIku6I.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff406d60a94_tjVzIKVOG6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F41965db740_CTJfjpr0rZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F64ccad6aa6_28S299OCvQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3417c252d5_VeGZ9aDw60.gif',
  ],
  '🤕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F06382746e9_EHVPEctESy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56b9c1840a_mg4a5Aw3Kw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F534f53ca4d_TwsFejQefp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb6bcdd6d50_YAKBPYd5qQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56a79ec481_k9qCNsgfws.gif',
  ],
  '💃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6a9a06ccbf_X9uQv1EoMD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3fec493b35_Q08QuUNGNb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F68566c28cf_d461eZndOA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa8aa81720d_cs6M2BurFf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb32834ccef_9CLXx67w4B.gif',
  ],
  '😀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa92bc4537e_hLDz6pBgom.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbc15c81ae8_3gyDVXLXRS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2662dc055a_Wh4FwVo0J1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F447c5e3778_rm7YU1HH0B.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc27e2aae65_M3ySx7EmVT.gif',
  ],
  '🍗': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0787c0df3f_6PpKPa9Tlz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6c9ecb33c0_EsKZu7eud1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F51309ef785_ZdreMoV8Mg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F49abae3b76_hU8BOGai75.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0d6a346e1e_KnRC4N4S5t.gif',
  ],
  '🎵': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F666dd2e4fe_Oknd3kJ5MF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F938ed394fb_WnNIr7DlAY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0ed5127c39_ToF19RRHKI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F68566c28cf_d461eZndOA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6634fc6317_roD2txzzIa.gif',
  ],
  '🛏': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1b072dd7cd_QQUEe0vhTg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fce81e4a497_gpe1U5RgdC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdb1a5f481b_mv7DnDzbJ4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3417c252d5_VeGZ9aDw60.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F89727a6771_HPW2jlxdn9.gif',
  ],
  '🥶': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F857bd799b8_uLRYtZ2CpS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5659e2992f_fD2FmU3U1c.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc2b9a1e71d_dnMER36stO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4b79a5a300_yjmHBnb4DI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6d808f3cf6_DFDXo0ADFk.gif',
  ],
  '🧧': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbe7e71ff41_USwsuDqQCa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F98db94df85_cLNihpoY3y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3902328d86_7WZiOjsVzF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0fc6beed9f_srDp5eiPE9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7eca146446_icRNdJ6H4r.gif',
  ],
  '😞': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F29c8b43dd7_UJtoXtoXHs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3eb67d5e1c_TzZSvaxIWr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff89cd511c7_86WqntYH4Y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fef45468224_LqidGMypNl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6c6caf435b_JK8wRmolfo.gif',
  ],
  '🎃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3b456714df_JP7HPGocgG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcd85e7fea2_5CNvtKhYpn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c3efcc8de_xJDeZYaE6V.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb9b4baed49_mqbTEZqoDn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb749ded526_BTqfuHOcTD.gif',
  ],
  '😑': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffb28d79435_sVjA0H8JXH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2da1e38a26_UEfbnHUBUY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59811e92b3_4KDbWRddoQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febb3a58e27_z1tKyxGVHB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6f09f059fc_X3k7bK9WML.gif',
  ],
  '😉': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5e4306a564_s465UqsdkF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F75bf0b3a2f_uxonrCjI3g.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7c717c1c72_1kPe11Y9r3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F297ebe6386_xN3OTeiVuu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff25ee8374d_rodJqFd0Fm.gif',
  ],
  '🥺': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c0de7ff4c_NHSdCOdEXD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff68e2751e_7LOmwnkMoJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17e430d075_kHvNnF9SVJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe7151ace62_bUQfcokD7M.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb2cbfd5bc4_WT6gh3XsI1.gif',
  ],
  '😒': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F686f370ba9_vFdMCQo8TB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5bff885b3a_ujNNHd1QMJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdb87febe9a_VOkwn3ETSk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cf182d0d0_RbF5TxCQcZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F07ad6370f9_5by72zB91m.gif',
  ],
  '📕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5ac863fc88_6n6FnZMGul.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56247f029b_K4R7PMKb5l.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F13359afeb9_PVw9JhE0G3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4da3aab0c8_bils7s3hd4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62d6b77a84_boH4CZgcjy.gif',
  ],
  '🍐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffdc27a9f83_4Dcx6NvlR0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F784394b2a8_nGxhuL5BuM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa56824d53f_fELybpuqgT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F67084d80b6_FdyinEipIu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6f3f21c6e5_LReDHUiuVt.gif',
  ],
  '🧖': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe7e5c1944b_D18uemtAbu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5c0c7742bd_vWmimfIPKm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17134fda27_OJaIfrF6DN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4795e44b2d_9TWXLYLn2K.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9f05a6e55a_RUrozdkWzn.gif',
  ],
  '🛀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd487d66a1d_EmhtjE9LVB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F471d3f6eb1_Gf5C451Nt0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdf7be442ea_HDUyZ28DYM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2bd06e47da_LqGlmlvkDk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17134fda27_OJaIfrF6DN.gif',
  ],
  '😐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6f09f059fc_X3k7bK9WML.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F85ce2ebb12_y74AyLuGAd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feaca5f4f7e_k7OJETUxA6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F78e59c3439_iFbdBbFlbA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe92a5f7c76_WdtvLnXwMp.gif',
  ],
  '🏋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F92f7fd7f04_S6aTbIzzFy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F300b3eb869_IzxBdw8XqL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd38035bebf_hlOlHGd36D.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9e9fa0d27c_u0G6eG2RGG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2f2132716f_2hJsZ36fk3.gif',
  ],
  '💻': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb8e1292487_V757v9MOT5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe1ca067464_97uYF0vUIX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8f79393ad3_MEP96sn2ro.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79c59cf27c_FBoK6EBuXp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb7dfea4101_EXbiTC1g8D.gif',
  ],
  '😘': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F51fb611d24_8SNgQ5qByr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F80dcbce790_cQUveVNWYr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F264c1f74f0_1cgGyNXhla.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0d8e825384_bRDSOGwC37.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0e295170c4_UnC84qXHh6.gif',
  ],
  '🤒': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fad885a6c54_0i45fQVxKp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F036166dba1_FMCurNNVvV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2128c16746_vibf72jnlq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9ea6bf993e_P99Kk79oGb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F127efe0def_HHqiQpYaRb.gif',
  ],
  '🥘': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf1306d4a2_8HyxX6Cscv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3665cb9c78_ujahqmO6Mc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb462b65129_TDfVjAPWIx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1a3b6568fa_GA7jaRqLDC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febe5a0e434_GmcqeVPqTK.gif',
  ],
  '✨': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17c21d0d36_nHF5XNfiUH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb06fe39f87_RalrUZX4tI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F844c693744_bV8uV6nDU2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8a604bc8a0_21mDIyfDOX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffb945099b5c6d37b970a93338a9f12ad_Rt6ENv0W5g_5FiIsmLSaQ_HxFsCW6hBR_17-min.gif',
  ],
  '🎁': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6330285467_m1K0DyIYBW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F91e445736c_R1eGrvRVYu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3eb688c31c_KSVT8wLJGs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2ed1680d58_vdKz3C3p1W.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F204b66a849_0BHDsDNj2T.gif',
  ],
  '💆': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8a8ebf059b_QQtmezcfWi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faa3261a8e3_4cYB41Yk9U.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F061bf1c558_KwOtNiGbk9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8ad9a5eeb7_RrD8b4Xthy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F13359afeb9_PVw9JhE0G3.gif',
  ],
  '😩': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7066b50404_KY0zn8Xo0O.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4dd69ea595_0qEi2kVeZe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3fc9bac879_BOud2uRS0i.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe1f590d07c_2y4UMBjb9v.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F21764967fc_74xwSaKhMU.gif',
  ],
  '💑': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc2b13c3312_0qM58KzHWc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8b953ed101_CJLaUBR50r.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fccb6279eb6_ur0yJBLP7n.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F264c1f74f0_1cgGyNXhla.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F01f38cba4d_mXxKf0fP2p.gif',
  ],
  '🙄': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe949f2b067_eAEla1jweh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F66813529b9_tIcFOzmEjE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F96913fb4da_YDesW1Jcmf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F49effffcb9_bU5CgHJZeM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F693313689a_nZ4cx0jd2e.gif',
  ],
  '⭐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0b6e0d0a67_YUxXBnTCUb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa38bf68692_DcmITpJs0v.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcefe3262df_yG7U5WgQT3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79f4bb3d28_AA5yrfF1vf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe5c7c89195_SAH0IBlLbW.gif',
  ],
  '🤷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F65bda89202_d5hcAUpHJX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F740eeb1e40_I3zBr9ItoL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe949f2b067_eAEla1jweh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9d145029cc_bsDTXCPEpF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9f996e5ee1_lcpksB4JCV.gif',
  ],
  '📞': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc3a12b3f1a_wN07m2FESC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe6a53ce483_Qh25Y9S8Ji.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa46935bac0_ynNJbmkQFx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcaf546a370_GaBEh54E7Y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1bcf70da55_RSS90pQ3Xm.gif',
  ],
  '🍻': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F72e1de540c_tnCftlsPtF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd565485b76_Bs6QQ5vfaQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa2470da8da_9AxuFyFgWZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0b71e78500_WslbT7b36A.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbe5d0bb6ef_vHGuE6QiRW.gif',
  ],
  '📱': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6b248f3673_0noagUeFsI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F76b680957e_GDzI4y27Hv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F827949cf77_8hy8hGqHfQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3fbd564bba6d6774c9cff2c5435be5f4_hXVZl6w2QK_2SQzYtFYRv_vLHU34IU00_weekend.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0f11b48b12_ZB8zsD8CNI.gif',
  ],
  '🍹': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdcf0ade86f_fw3rcs5lpK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c0c754864_M2fHFn9BSB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0ca118a7b3_FDE30JBWPt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6e5d62e27d_KQVHhrD3P8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7951d6c0bf_w9sUY2BuvH.gif',
  ],
  '🙌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c37579017_1EmrvqB4Xi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fee122eb7e0_NBjp4gxemh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd38035bebf_hlOlHGd36D.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbdab84ce6b_yQxpC7IbRF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd14ef6f0c3_b8vHHQw7HW.gif',
  ],
  '💦': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F30c176eb40_asRB3HRBED.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdd3507e82c_SZEuZRnerI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe1f590d07c_2y4UMBjb9v.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff90fb3c3c5_pXm8qFX5az.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6d9e4e5d19_lFHCiP4uqv.gif',
  ],
  '😎': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6a59b07ea0_HDb6dHmMoK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F43abd491b8_GHROIk6luC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fafcf8520b8_EuRxOOwDNw.gif',
    'https://img-i.mojitok.com/emoticons/w300/5bb88465df_C2Z0gyL8JH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6a0fbf90f0_FbxJKbqAVQ.gif',
  ],
  '💨': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F86497f66ea_63ozStDiuG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F58bf6cedcb_Yx5DWTL2VE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fef9f6192d3_vJnyvSrfAj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F18ba56975d_cW23u2EkcF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F249b2d467f_zfsJbMr3Fk.gif',
  ],
  '🐵': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feaebe94fce_LNnqdiAEMt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1ca887eb0c_S6wbJAsIH1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F324ea20a5b_dKUaFmDeV8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F71417603f5_SPaZPQhGjQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe58cbb859b_SEaYKx5nTF.gif',
  ],
  '😷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd5c967069e_M9QoxzD9Fg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0a089b90a7_KK8J9axllx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F810b28a1df_HY7BWKsS8w.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F127efe0def_HHqiQpYaRb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4bc4d284f7_LufqiYZ6Ga.gif',
  ],
  '☃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5c6a5f1331_Uwyf69ZHmU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa605de25c2_7zeIUCb4KG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc2b9a1e71d_dnMER36stO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feaa5ca11b3_xACga6HYmr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1ca0afc471_eruAOUGGIR.gif',
  ],
  '🎣': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7758797fdd_p2DyM7XTyC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2c63d28626_aGS5pmUNop.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79e26af56f_A5ZfyKZ9hK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F910cbb9ed3_U5NrpD8l84.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F479964a4f4_ztKhU9saD0.gif',
  ],
  '🚇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F00fa5d897c_GhMZGUy1EL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6385c4db68_OAYG9uNUei.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc5ef8e9bb5_pUlct4Yqzg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc89570264_yh0A0Bp4MD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbafcb302bd_OrOXj1qDIP.gif',
  ],
  '🌺': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F64b7c0c75f_HA9kw07SCU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F405a5690aa_cRQHHAWZBo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f7d391d84_56bEDo0HUT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F86f9424f15_7NA1xF9k1a.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc27e2aae65_M3ySx7EmVT.gif',
  ],
  '🧐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe0c5e56f71_gPdyV0nol3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6076cb4489_8cWMrhBDVL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F486511e7b7_20xprDdIl2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc5a7a148d3_pCz0TafCn8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff72de9864c_GRFyjexQfq.gif',
  ],
  '🐣': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa18ae420ff_2Zevim7onz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd72f15e141_lF1X40lcws.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffbbe1c3709_r0xjSAhbnX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc1f9771a8e_b8LPrfGIHE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0bb7337b75_NxAoSDeUNh.gif',
  ],
  '🎄': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F068b2b2e5d_oDxVudJYI0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1ee7747974_tmRVSYGnG5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F41965db740_CTJfjpr0rZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7077b2867f_Me6tV6CwA4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff01ad0ff38_IssdBIEBfl.gif',
  ],
  '🍺': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa3848b1131_MPldW57g3y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F77f5f44384_5UWIu3tNOj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F51309ef785_ZdreMoV8Mg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F21764967fc_74xwSaKhMU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7ea3db80db_RTse8ByRli.gif',
  ],
  '🤯': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff416ad04c9_Yc8Z5gX7Bn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc016213acc_3zQ7f82anm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8f79393ad3_MEP96sn2ro.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8be4261615_VQjL4Ngb2g.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff022b19f74_1Z8iW0uSCZ.gif',
  ],
  '⏱': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c2c19a1e9_pilIisSRGO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffad7754b25_NEgAIWEJrY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3265ca05a6_I9dTEVdujR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F10038d7011_NPliRMqLah.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F389bd49a75_Gc51hbnW1B.gif',
  ],
  '🧘': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F147350ae01_ximdTvIjkP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F92f7fd7f04_S6aTbIzzFy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F71ea46269b_aADaImX6Ox.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F328667ccb3_GN54NUMkKN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7f503dc265_Gh8dbG9AlU.gif',
  ],
  '👽': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbc306c68f2_GIAugzOB3a.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2b89a3a1097956c8e5d25cd21892c1db_hXVZl6w2QK_TbDYQpDR3J_sAk9Hyqby9_beanstalk12.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F398c8502e7_jYBapo9OHD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4fc77113a0_08ipqfYfsG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6c0b293d09_EB2DfPSUBK.gif',
  ],
  '☕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffd9956175f_FHa5hopJNN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F268d675631_Tl86kbbjdK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F061bf1c558_KwOtNiGbk9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3fc9bac879_BOud2uRS0i.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F147fa424b8_2o1wC5a7tn.gif',
  ],
  '🤑': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbb59471a19_xh4ed5Hxpl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faff59ffc29_DPLZrDs6LU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F43abd491b8_GHROIk6luC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1958c8a5e5_OZpI0s3txc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd1473ad5d1_Bhffll2U5U.gif',
  ],
  '💵': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62919e16e1_1A4zHRiqq0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cd4898c62_hsqkGoblCe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F43abd491b8_GHROIk6luC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbddd5c1649_lXWERC0s3g.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd1473ad5d1_Bhffll2U5U.gif',
  ],
  '👻': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faf6876959f_hhtYLRdHfj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe32ab19af4_eogFQHRijx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9458838079_G8MMO6jIAN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb56da876c3_bTVpPf6M80.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F40813c7bf1_i0V0sYNncQ.gif',
  ],
  '🤚': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F55f71780dd_KfAXUHCqwz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdde4f81eea_KcvwLpwJx9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe7026ce04f_D37uEvwz0S.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fca4f5543e5_NPr5I2pyAj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd0847a306f_2dwnfToDo6.gif',
  ],
  '🌼': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c80039e67_ssUO29Hs3r.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd63e8dffa5_XLANH8XOIg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe4779f8ee0_GYItFPSPLv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F86d72ef223_62vXUbLUeh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0be8742715_FREqaLZq2p.gif',
  ],
  '🕶': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3cfa0def7a_S42yGBrdl7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1cfbee4755_AqwMfSf46p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2c74b39513_HiqXWYfAdE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fba72e42553_TFFYhHBbyG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb04214b9b4_pVje3V0kdx.gif',
  ],
  '🤦': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa4ae02a230_0y9t9fq6SC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F13165f424e_7PtQMXVQ2E.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8796721205_BSTGCSxbZJ.gif',
    'https://img-i.mojitok.com/emoticons/w300/40ccddb108_bDCnJAkiNQ.gif',
    'https://img-i.mojitok.com/emoticons/w300/029faadb22_l27Qmelqnp.gif',
  ],
  '🌈': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa4ec6ee824_aB1mzFfc9S.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F428bd24ad9_yusC6lVKtk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd713d9e9ff_6sJL2mGlDl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa2f3fffa78_7M80qYmyCF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc3573417c0_D5HfBhXajP.gif',
  ],
  '☀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F33a8790209_asmgdEqcsM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1bbede165d_CqL0QtEKqd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe4779f8ee0_GYItFPSPLv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0118e82d34_IHAuA2XNiO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F08e58744fb_fMmUVWG9xH.gif',
  ],
  '🤨': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa1a3695f52_BxdsXeCKYH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc61229db79_9k8EoM3rjy.gif',
    'https://img-i.mojitok.com/emoticons/w300/ff75776f2c_Xkqdblq2Ll.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb6b30b2395_cFiCdC2Npi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F41ac4d7dba_KazT9Pp9Zi.gif',
  ],
  '🤔': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffd4f84f3e1_e3QnECQ78y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8a6b7ba46c_898JFiQULq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdf7be442ea_HDUyZ28DYM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6476273abc_hHugFTKMB2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c4869a29a_5ZPEfnlRU0.gif',
  ],
  '👀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f938c6093_h2AA7TmSsj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faddbabf9c3_sBGrop0JGK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0701c64d21_Ng0pNP7Q3s.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7e4577b5e4_WQYHs1qMYy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe4d79b25dd_VZ5f1Wikze.gif',
  ],
  '💔': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd856e037e8_jFoi5Xk59y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F553c0433f1_dphVuyAqlK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3c0a9331f8_XQKGPV0N5U.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffbbe1c3709_r0xjSAhbnX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7cf5f4af95_hGNZ5UMdRY.gif',
  ],
  '🌸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F71d8fef905_hFPw54AHEv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9e80901246_I11OOn2zVd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F266164abb7_4OC505gnSM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F25c4a3bb92_DA3Vbpes2b.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb12d2aa347_CwXjMnkUST.gif',
  ],
  '🐷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc315c5afc_PQzaiDCi0k.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F041f29d9ee_CK7Im2cwi6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff13479337c_rzrpQCDUqf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbeca991c0c_pSf8GMrB7m.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F89e5f0412d_FpOEHGlDvH.gif',
  ],
  '👨‍💼': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe91b5ef67f_AaG86x5t8M.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd1d8ab36a0_GRVSDOI2o9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F24402a035d_kQDhOfgWZQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F095a760db9_P4LCEPNSMo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb7dfea4101_EXbiTC1g8D.gif',
  ],
  '💩': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faac0dfadf8_MooauOT8oV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1325c2a88b_yjAeeZaefP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc1d8e272d9_EhEZtTpJqS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9a7a46a031_X8btYcOnMM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd5a4995270_9HHGcOel2R.gif',
  ],
  '🕴': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6c928703af_xWcQ8gOThZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8df89b14ce_FKWOA5gEFa.gif',
    'https://img-i.mojitok.com/emoticons/w300/8bd0378910_Y1cpUZsxH0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdf7be442ea_HDUyZ28DYM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F147fa424b8_2o1wC5a7tn.gif',
  ],
  '👹': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F96b8e3707f_jSaQ9vVLQQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe379bc4ac4_7dUs14u4sz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F734603ddcd_9j5qcaNJpf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F395f73af8f_Ek88xC5v8z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F416b6978ae_RGI0iF8lIU.gif',
  ],
  '🚗': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F55cd4dc8a9_AkNmG7arKU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5e6592e9c7_H87unfEhOS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fda2ef6903d_M9GnknfEUO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffe8a26f7bc_xf9EGGE7O9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F99cf4cf96a_CSXCfXBidV.gif',
  ],
  '😣': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F872deb6ad3_9z6UkdmkNS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe1f590d07c_2y4UMBjb9v.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F166bd765e7_6M370GWJLV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F97679cb844_1zt5KI07K6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F12e98523f1_THOdT1T9O0.gif',
  ],
  '🏃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62adac70f0_mg1EmJTGKE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6434841898_ZY3TcOjAWD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fef9f6192d3_vJnyvSrfAj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F249b2d467f_zfsJbMr3Fk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F177a403d0c_80pUgqQfde.gif',
  ],
  '😋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3253416c0a_FGv9uwCpXD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2e9d860c50_y1YXWYYYs0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c2060a705_GBTvGGGnPd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5ed0a5de0c_YYQznU7faR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F75132dbaae_nBSmgoHpEb.gif',
  ],
  '🍖': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc2cadef9d4_ZfGDuOJ1GC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb9bbee5df9_q9ZOW5uCU4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feed47e0fdc_zMPGwCVECd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F820bbe5e69_D45VYfGNE2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe8d1558e25_JpJNZpC2qU.gif',
  ],
  '🍁': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4e35dcc4b9_BskpvIILUi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F215a158e93_qSbblOEHmh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d5e5a744a_PExqFoupq7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa808337d3a_Y7CBuBXYcc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6fc4c86241_RYh2Q7Ani5.gif',
  ],
  '🤼': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F10d094eea8_cJwlXl8sPD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff6c7329c96_7ZTwys5QCV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdbc7bca480_G04mixAe5B.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F688fcb91bc_tEo4MTRp2l.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc3770a584c_jvrjAh1vpY.gif',
  ],
  '🧇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F49f603a522_pGfol9Oupy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8a667720c8_YBfGt2jJm9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff625b40319_RY1ZOOVFpr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb0d3143f64_Q9ze2s9ijH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdad3f45254_JwhNQ4ImPi.gif',
  ],
  '🍵': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3e5bc3a578_dHD9QPmNgF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F689400847b_pk6LPyVcFP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F061bf1c558_KwOtNiGbk9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febbbdecce6_QHfAD6R9qH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd60d900dea_omgIyafCE0.gif',
  ],
  '👎': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3e4c85d6f9_k0ILH1hIPO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe8d8bcd23a_7ZEY5B2G6W.gif',
    'https://img-i.mojitok.com/emoticons/w300/bcfccee260_p2COUakRgm.gif',
    'https://img-i.mojitok.com/emoticons/w300/c1b6d9b714_l5lBRXbByr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6be245263f_iKOKfQrMxR.gif',
  ],
  '🌅': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe24b123491_X0h7RoRUaN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0118e82d34_IHAuA2XNiO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F57c79af7f4_su6weL0OLE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6c14b0236a_eSqm5a0dYc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F21de2cd771_AIZRjv6lFO.gif',
  ],
  '🚶': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb2cc22181f_jxoKaPFnA2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fea4e03f043_BGCUlCWOdH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe49b6ab56a_WBz9F7oGni.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F797eb07067_Wie8YjwL1O.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd2d41c629f_UddCwUG9nu.gif',
  ],
  '📦': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9814fbdc01_1MenihzEqh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa7f2e7ce6d_rPyGT4twTF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa5c25c3b10_ND6hW2iBEC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe0315fe4e1_YbAG4flz2W.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F611e25928f_dH03QK13zD.gif',
  ],
  '👊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa38a860920_6xcjmqRUkk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F986a832478_XMCFMlCbjN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff344da4eb7_2VFRSlHgwB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcbd08b6628_AOSnIgoivl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd930bb99da_g7hMKy9QEg.gif',
  ],
  '💡': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1bb3386735_1gZsDZugU5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fba624488b8_rxUfKBiwuO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59b9caaab1_GWmzof8jcs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0502130cf9_Nbdfi0zUw0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2f5ba0a85b_mVjq2km2hz.gif',
  ],
  '😤': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbfa03354db_I2rxQZkMuG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa9a18d265c_lvqKWiTSbP.gif',
    'https://img-i.mojitok.com/emoticons/w300/d34306a7b9_YrcxMv2vBt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cbcd5bffe_rjsvOnHIX9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F70e22e4ca1_f3SyKSwHn4.gif',
  ],
  '🧎': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F537fc01969_vbG63vuIcK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff2173d3aa5_WK5Ev7WlnW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb63c06ff8a_3fDRoy35Ra.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff24e541353_B2fy9infMp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd8b51c9d02_CRt17T1Hbj.gif',
  ],
  '🍨': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F962d7d36ba_NIMjrZbpQh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f6da81ab6_WCXmtoo7MO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cc89f45b2_OZ7pEVtZb5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F67583dcf02_Z96dRpquTS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4c9f63660d_5DZDQm9g5A.gif',
  ],
  '🥁': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4a75e67053_pFDf7YXjvY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa277068e66_Z0yGboFZkz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F24a1553d85_8YMrRFM09x.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb1fd09cb4f_wqU84Dkoee.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F74049358fa_3da3FvMeNA.gif',
  ],
  '😶': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F05a4996802_L4S0QsekT8.gif',
    'https://img-i.mojitok.com/emoticons/w300/e2d023d728_Pr6LihHkNL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe92a5f7c76_WdtvLnXwMp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8e8bb7939d_2EhTd1AyNn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8359b82156_W92vpZ0eD1.gif',
  ],
  '🏍': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F33b661e6c1_yExu5LBXaT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F02e1074813_gbHwpCGDg4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb6a9fe349a_rqLuNCJeyD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4e50123a1f_O1pHCboDPK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd9c1b76ea3_EUBqYjjrq7.gif',
  ],
  '🧞': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd2840b55bb_RQUEhCudzS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe3e9489497_HaXdpSvC3p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79f4bb3d28_AA5yrfF1vf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59fdf64ddd_1QBQOYFj5r.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdbb4c72ce7_sBJ6qHxCYX.gif',
  ],
  '👏': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F07062ad7bb_HTRMYTSdst.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fabc72389dd_RYqQwOR4pW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8940825dfc_8VbDS2qSdq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2a99f2b964_TTe82aCpsS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c2bd0de54_plOhrH2UeV.gif',
  ],
  '🍀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7f3d0fc739_Lt86LFkLWH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd92467c8ef_cZSCfvIvFr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe4c6fa7853_EPoSMohtNG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa32c036564_2F96DjR97l.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc144f25e47_lUOcoUhcgQ.gif',
  ],
  '👶': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa18ae420ff_2Zevim7onz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F37d2a099b6_RZs1GSrnEC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3510ef22c7_ZA91TIsdvt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F67e686cea7_gUWX4ErOPb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F21141af2f5_7n9Zi4SbTX.gif',
  ],
  '⛰': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fac860d72bc_oPrTixGUvM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fce3833d40b_DU9N2jSL92.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0273585bef_EXDu1hKgDq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F82c34cff4e_WY5xmDBIRl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3ff9a58b52_p7bz3uIJQN.gif',
  ],
  '🥄': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feb4e7468db_BNTkaD1AzJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fae9aacc690_J3h9pogRU4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8367916705_VlMAygsCQF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc0b59bdbb8_YF3v7qiNps.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F35a3857f47_azKwZTEHml.gif',
  ],
  '🏊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2f0e1066a9_J7WX7EpxQT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7d1dc13bd8_PlhPhwdCUh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1a21a30ede_touDs30EdF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd92fdd7969_esWgwQQb7R.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F55b4a03acd_I9QoDJXFXD.gif',
  ],
  '🥕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3a9edf0084_if95ai7K7k.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1ee296ae08_hy3YmddAq0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5f1eb9017c_ADC6dH5fdy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff955a3d696_7g6WVvv3vU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4d0ed42c70_TjQQ8bJJqY.gif',
  ],
  '🐅': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F08d242c0ac_duijeC96LH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F234f7de1b3_mcDGgyvzkY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fac946e5a3d_4uTbJhrjrK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3836519c74_M9YO85MheJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff0aa6a1bc0_ZvyIGRpEo8.gif',
  ],
  '🌨': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fab03b2fd68_zEXRY5kMMZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd9beffb740_5tnzGFo1aY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd301049fe3_3IUK6Fql0z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd6d453133d_DQAwTh2zBD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf56977fad_uoDmwR0Lmh.gif',
  ],
  '😵': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0d2ee4f389_0bhNfMQzXs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0e2cd465b8_CtuqlstBVr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6bae67b535_JBZQ8l2UPM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9fbee6f949_jM7NomzG4y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3f6546941e_Vmx0UcwTp3.gif',
  ],
  '🛍': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F618014f9e7_X8r6VACBRO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd62c48b0f6_FXldyhPNLJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffd526f98d1_HCGvY39OYK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0a2af8345b_wJcZ7dlO9n.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F529578bb08_wFiQGBNaZ9.gif',
  ],
  '☠': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbb49037431_CMqTzZ3VCZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa0f29bde8a_oVaRMRmb3t.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc7ab4bd7d1_dGE8TFQxx7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd928075783_Bcj6qpVW9Q.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F40813c7bf1_i0V0sYNncQ.gif',
  ],
  '💣': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fffa44edc0e_UCIHZleC9S.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c1a0cec35_DYGz2ROCC8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8bf5eb97fa_wNeLsCJn0Z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe88b43808c_BlzWpVkYfF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc5767bef8_8drZUKPRjb.gif',
  ],
  '🌹': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff48cc7ad3_UEIeAQJnXS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2505621227_b0t4CvjBeB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0be8742715_FREqaLZq2p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F001c4689b9_Fj0Do2Rytl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F43016ae473_fCHPeoPA2T.gif',
  ],
  '🎆': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F64dc680756_2ZAOD3Wy9a.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6a8f512a8d_1r7j9jCmOJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc118577f2_Q0ZgDXiDXS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F49e55f0388_KHtU5sGyka.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5346badfab_wXTGHenAjZ.gif',
  ],
  '🍞': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faeac9cc72a_keqTt05zhk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F771c39da4d_BYCfJYbjK5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6357655d40_GjULe8kbdu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd92559bcdc_wWhE1KEcek.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d233bb008_cF7L6wCcam.gif',
  ],
  '🎧': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1abcb91ec6_AIcWpuE907.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F73a3fc98d3_mR6tEtcpI4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6634fc6317_roD2txzzIa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd3453cc8a6_N0cvHMtDeB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F119ec4c822_2nnncjwonJ.gif',
  ],
  '🦊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F265083870d_W5iy0P8DEJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd5d396ddf1_BpsQqx3ZRm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f9c1a6281_0X7ZLX5DIB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0bf641fdf4_MAZlkpROWM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17c82f21ec_lZ8BJx6LEa.gif',
  ],
  '🛒': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7443c226d8_fDhT65WUgY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F42ef2055d1_xGEJb189ye.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7d29b50598_sCCdZoITRy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd4a521bbe1_V61NqZDhUT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2266c61e59_mATK8BsLBR.gif',
  ],
  '🧳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5b44bedd59_RtFvlEnpS4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4b8a14f621_GnrmPrGd1F.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa8d31f9214_l6eeyKtp8e.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd4e991b838_H4OmOgRyNw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9e6a904f55_xzKb0ipXte.gif',
  ],
  '💐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffb4ab96371_NdYUdeT2uO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F19d19a406a_tnMIieBlvR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fde1edac526_fGn7XqMycg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2aca69f08f_3wymfzVsJi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5628d42291_Aj8ZXRT05l.gif',
  ],
  '🍯': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd65e9fbd94_7b2N2DD6AH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F35a20d5346_9vDDUWQSE7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd936bb03f1_jCNF5HY7Gj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F84ee736a4e_KNv5B8GEu6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F875f782df6_K4UL9gC5G0.gif',
  ],
  '😜': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fad9746d216_k20qjKvKKO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F57b13c2ec7_1RW8kKuCg0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fac946e5a3d_4uTbJhrjrK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe9a8cb7350_LVGtM6XpBa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2caf7a94ba_QOVZMyNO7U.gif',
  ],
  '🕊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F448ed9abd8_iDssH3GYfe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feab73ab7a6_zJYoLNbxKH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff802fd6dda_kFiPeBHESy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2d303fd51e_C625Bbdf4e.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8db83f9d4b_6yYUeTYeeE.gif',
  ],
  '🛑': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbd059ec9b3_7cepJZPmaQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2d3619125e_ISMqYBZcQ8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdfd96afd71_ouIHv0yOYs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F373227fd95_HoRRTcg1to.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4c908792cc_ecset8TeG1.gif',
  ],
  '🥤': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F36ef7aaacd_byrbS17iEB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb176ef7ab6_mnTWrBhuFk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd46544a94c_O5L4zR5Lm4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff6a220d58e_r8odTr4ddX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6e5a00a843_DKc2rADLvm.gif',
  ],
  '🥵': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6b92c4aff2_C75FMzHuTc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5c6be66b5f_bjhzjHStPR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5c526cd25d_1D1Zzz3pba.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4512176ccd_uaG54cXrmE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0fac44784434ebe4a54c259a3571600c_Rt6ENv0W5g_5FiIsmLSaQ_pC7fPRmCtI_23-min.gif',
  ],
  '🌲': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffc515ae832_vCtC5Fhk9p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffb87443574_5KGjBC6peE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F86e1114cfc_zLDtm7BOpy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F02e1074813_gbHwpCGDg4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f8b4896c5_CIOu2iFJJx.gif',
  ],
  '👭': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc938bcc288_6RjmZPTG2W.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1d77a2c77a_5A1bBdx9at.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2529140025_MOM3v597ps.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf2132f381_0WtLImmmbi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F08cb95a519_mrFhsM8Uog.gif',
  ],
  '🍋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fca56aed2b0b9218a5a3a69db89feab30_ucRPwekTch_jAj3WRk7tx_hmXLjUmHXa_%EC%A0%9C%EB%AA%A9-%EC%97%86%EC%9D%8C-1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb77af15aa1b6e8f4bd55fc55b3a37cde_W7lcZSjBel_quALZcpgCR_jKyiiSEbGS_%EB%A0%88%EB%AA%AC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1b95044cf0_A5ZGUaAb32.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8a173e6523_FpZvWrIYNt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd816dfcfa4_P2Yti8ugz7.gif',
  ],
  '✌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4df3e0d911_n5Hvb8OaSD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcfdf40f21e_9TWNBG4YPv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcc094e3b65_HDvjchBfXh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F773f7a0ada_H9FmkLtcKg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd671c1ba46_livREj42QY.gif',
  ],
  '💌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffb2f2ce967_EcqcHleo8r.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1cd7ae353a_P24LaJHcK5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17e430d075_kHvNnF9SVJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F63e9eeab38_sKWIiVdKQS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1ff26cedfd_7gHPRW85HE.gif',
  ],
  '🤓': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0a89f73aee_NNLkgWeY8x.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa2347ed912_nYHZEcxyGg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59bc471b08_BvBCYEtNTs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fed048983f5_7u3zA8Z6uB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5ac863fc88_6n6FnZMGul.gif',
  ],
  '📖': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F83fcccd7b0_25rwRyegVw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F366e5fae3d_I96mMGrbHu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62d6b77a84_boH4CZgcjy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F97c42f203d_0Jc6zdmiOG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59bc471b08_BvBCYEtNTs.gif',
  ],
  '🏖': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff2f2484477_DL8QQ62KY5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb1d7f1e961_IOYKp5n9tC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4fd1d52776_Qg0w77txtu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb16c7f3f33535adb3808fa5a2aa96589_hXVZl6w2QK_2SQzYtFYRv_WUozSBgnFa_sum.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F68dcfb5887_fpl5f7knz0.gif',
  ],
  '🧽': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F11cdc3ec4d_3VKVI8KwY9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F28e47ce64d_9vaGjHcbCl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4eba19194a_fzQAkMcNsQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F87dc706a6a38f89a65ad2de130d4b7d3_LH2FuLmD0R_UHiGVGxckc_zrgiP6E3zP_2.1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa0c0aa343d_fejaWxB6x9.gif',
  ],
  '🍌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feaebe94fce_LNnqdiAEMt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F53d7428a1c_LEtWGCOEFU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4bf2905c4a_K6BZuV1F3n.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F87d393a862_tOJQoivMaI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8c6c96a19d_Es5JVmyNnS.gif',
  ],
  '🔥': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbec110f779_lfA07TmsFk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fac6678dea9_ZKoMJHpQ1C.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fed487ca02c_ms35zxqjC6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cd6429c8c_75O1LYkkWP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F44f6700c22_zV1pOTWfjM.gif',
  ],
  '🙋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0b0c92b476_zr8HEnLXY0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe5bd4dffc6_6lSkwiF6Hx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7e0a549a6d_DGdegyC8zS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d352a8ee6_4PE4B3CTqF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8ab9911818_ixSqLx8TEe.gif',
  ],
  '😌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F879432404c_pRORO3g7Sh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F954b59215e_ZQyUSIxlNf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9ba306a181_70MHyy4Mdz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F81976782c6_Lud5GmI5rx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd4550bec39_YSxYVF3O9I.gif',
  ],
  '😏': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff32dc1e6a4_VmGu3jk7cQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4a2eefbbda_4QCKe59JGH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa584d39b71_D39D7EKBow.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F801f5748ae_dytOBbja9G.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5cf80f9cb6_7cE61KHhbN.gif',
  ],
  '🌧': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc3ad9c3c56_OlvvAgJVbe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F21da54bc5d_XoHH58dg0F.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb063b7cf6b96716a3affd3ab61d9a7f6_Rt6ENv0W5g_5FiIsmLSaQ_JWlQaClPx6_15-min.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe3347512b0_0JoVNd8Jyk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3a5c71d376_JbKDFBV0Fg.gif',
  ],
  '🔋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffcee7b7c3e_H6XUDDz1Wc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc0bf09fe90_YdHHGYHXZG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6edeb3256c_nVO50Pdifj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc03a669c01_L8LLoUA49f.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa22276691e_gIbLAvgLxW.gif',
  ],
  '💬': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F47b9c29685_JulgM3YNHr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffa18eb34f1_1Gskcy1UST.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7e0a549a6d_DGdegyC8zS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe6a53ce483_Qh25Y9S8Ji.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F00cfb3754a_zoxhwj9foY.gif',
  ],
  '🤫': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5f99ab3644_wRVCHDhOSQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcdd5c1a052_rKsPYBN96A.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F84a16d426f_yY2DjuRCnP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5e5432ca1f_zdq3jljMGp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6581d96a01_4oxaEY3gRa.gif',
  ],
  '🕳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F78dc14a692_oKGG7UJDyv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F87da8a7648_8dxmpw7Bts.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F675f2aa16d_xzhVDJgJFI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9002e80fe5_ac9PGqxCxP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F50db035f11c24e2843d09118bb9c4cde_tEYOZPZOTr_sHeyqz1WK9_Eg5p4LM4PF_GORO3_011.gif',
  ],
  '🦟': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb9a6a4e432_vaSJjSF6wm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff5a5a878e4_9ayigzgkpM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdbabbccbc8_o22gLcbx4H.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5015dc63cf_kp2R9a8OUR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F658d004bf2_NGJ3xCvHXZ.gif',
  ],
  '🦹': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4f50eca10c_YMbPDvnlaV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0d6ff01d99_vvxzACoNEu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8575bb4717_TW7aXrAlge.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5b9550d49b_zMLhEKDieb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F25cf2540fa_peAMz7ybaw.gif',
  ],
  '🍕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1a6bfa2db4_iLe94dphR7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5427fc436a_AxHgxaFS6B.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd8f0ffc818_8UoTWRwZKI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6bb865a145_3KWXg2Fcxk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1143e498b9_nFuSH8OkxD.gif',
  ],
  '🙈': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff1df150160_ajbC4oD3wx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7d22c738ea_wJJE5TtQHH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9f7fe2334a_h1d6kbGkvx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa7543b9ace_jr3lBLiGnk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F89a414a5e5_FGqMEaraQm.gif',
  ],
  '🏥': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8214261db9_76RiHMzsOx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe071c2c49d_epUUBEFb5T.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd9fd88d3fb_PO8yhu6xYT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8d0d719f2f_LmZNvIBbT9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdcc0d36a7c_Z8yITQUqP5.gif',
  ],
  '🌊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fef8d4f3918_FCeGfGHDtV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F924d310133_vLAUShnQAF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c4869a29a_5ZPEfnlRU0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1fb5742781_fz2lSzsmGT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff5142ecc70_SevHquPMiv.gif',
  ],
  '🤝': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9efb6851e5_jCYJcanH73.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F30328fd258_wWMFnTkOFX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa93c2bec6b_ygLyHnI3pi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbe03e5fa2a_73nf7OfE0u.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9fd81da1c7_vvRSVdoFEU.gif',
  ],
  '🚽': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F74b16f2721_rGv3FcUOMV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6b9e96e07d_czyiz8PIiK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F23cb63a4a8_e9P3BIIRxM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9a7a46a031_X8btYcOnMM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F52118b7483_xVzL3tlcvi.gif',
  ],
  '🐭': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F20d719e803_Und0AZeWyX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fedaf3af4a7_dc2SGmiUK2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F11353006ae_kU18q5ezqJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F103847009c_p4EiVYRkV4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F632c8f0926_aTi0gs90zc.gif',
  ],
  '😇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5154aec807_cjrB9F70KH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F644639aa7a_LMkkrAWOJt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff48eaf5f9_LzLLpC3ia3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd4550bec39_YSxYVF3O9I.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F795e92402f_xbJXOxrKzr.gif',
  ],
  '⛸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F10006ec5ac_2bnp6c7FVa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb26f726444_ZFTFekZxgx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62a4e87147_L6rcTG8Tg4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa9154866ad_h8FvSzGDNN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff174b9b4ad_yGSUdSQCiM.gif',
  ],
  '🍃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0e1e3abc7c_cplEQtmRnJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F30a6b8da22_vFsAmtxBkS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa808337d3a_Y7CBuBXYcc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8640a43622_HH8Q4QWoPg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F64cd92a116_CmH9NGiB0G.gif',
  ],
  '👨‍💻': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4ff9087f5f_JTMOmD6D7b.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb782f02864_xfw6iwAgSu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3b6cfd19f6_rEMe64FcS1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6851c9bcd3_wLFGKqELwp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0876c4f181_CfZJ2Ou66B.gif',
  ],
  '🎹': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F69cddc69b3_gDeCeHARPf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb1639db7b0_K3TPO6HAyi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F47d4b01316_Md2Ns4OZ6o.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fac3cd977ad_t2RneaYF9O.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1836a741e1_eWegtCmbnZ.gif',
  ],
  '🍇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F404aa2cd8f_i0pAowxEyg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff37d5062ff_EtiajwNhMI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffdc27a9f83_4Dcx6NvlR0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1afdb24529_DfQXEV18IF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F393fdcd550_Y83HQpCwHV.gif',
  ],
  '🤬': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F716300f07f_TWWr42WPt6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F139ea1a7e0_61lYGnpipm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb6a9f3919a_pm8tjI8A4p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F44d3c38fd0_OCYFkijIYV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe3f89d0e85_oszEOsiFhH.gif',
  ],
  '🥖': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6cb94c2121_dqdhq7D83C.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8ee10f66a4_Ow6DkNnltq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F24800c3bef_ERwNY8pVWL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4eb179d22c_gwxfafOKgE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7c487b5479_7Wu17jWOEA.gif',
  ],
  '🌭': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8e0851b846_HxiVxJyeIa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8c5e87ff5f_sTOm2YkU7v.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62a7818c0dacd672d837a06327fadc78_SgbZxgrWuQ_LvM6ZsqNok_moIN1freiS_mojitok_10day_07.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbd7aaf42f1_MZriN3hwtK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F95083b8ece_n9AmwDB46g.gif',
  ],
  '🤳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3c7d77372b_CyTcbiZxx8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1fdd94839f_OcgEECV5os.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd6ab2c3a0d_Uzsgp0FGUV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F08b29d618f_uMRvDgYpqf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc033cabae5_k2EmqGuecD.gif',
  ],
  '🏀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fea962a6443_KN1wIoWXFl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d330ffe54_s9uu6Qwkxo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F74981d5fe9_CiBBJTO9zz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9fc9589f73_QFoimeZR8k.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F33f0b6a75b_pDhLz8kcG4.gif',
  ],
  '🦴': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F106d99cc19_VqkdqMyE5Q.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdb56a1e40c_3Tr9jqPQvQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F94ec4ed5cd0f97d1ceb43422fb194565_Rt6ENv0W5g_5FiIsmLSaQ_DGKPjHAkIU_1-min.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F477e512c62_moHf57kpFr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F69bded62dd_InAaL2OCbo.gif',
  ],
  '😈': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F81f4b793f7_wI1WIMrEwA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F113ba8786d_l5q0WFGhDN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F801f5748ae_dytOBbja9G.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6b661b57dd_K3bJu9VR1w.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1d1d903662_78qPHqwFU3.gif',
  ],
  '👓': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F22b08234944be1df530225328323ce21_CJoZI6Ztck_yFnFQGpLBc_0bDZTC2k7i_10.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F756073521c_mYL6ZDAyT6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7bff00928d_wWvHGLoJJR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F81a43661cf_skZFy6Ld7D.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F83fcccd7b0_25rwRyegVw.gif',
  ],
  '🐧': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F651279ffcf_VtizOMG6Rw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1129459ab5_B8ofDRmEAx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe3d0c59eae_mxDHzG9Ys8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb52ef59d3d_XJGPNyMvVY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F413150940a_cMoERF3Okm.gif',
  ],
  '🤪': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd153407870_WKeUDI85LG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd91fb8f4fd_XNjlRjwmNB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe5d7d90188_WjZiUVl8Vl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F925c05621a_ZomaGVeFKq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F47386bc7e1_quF4hNSeCf.gif',
  ],
  '⚽': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc058a40a70_rcILbdkU3l.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4d6ad66c8a_v0pNQDdDft.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc856f46150_lw1pWE7xul.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe83a7435a1_pQg5Fylzwa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3c421ff45e_FYtrQEB8jx.gif',
  ],
  '🛹': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F21983e4f7e_XJujEAPJ95.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F180640a103_aRXdREvbyI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3265ca05a6_I9dTEVdujR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5f8b21eee4_zqHnOmx4a9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4ba1f53ee6_wSi7HFx3rn.gif',
  ],
  '🍦': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff73f3880a3_I8pGGwyWWa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc8a31271c7_6s3SFbT7jB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7f15dc1989_FGoQD4Puk2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0154b800d6_1pltBkMB5B.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2e5a6e6f4e_UgblQMoufr.gif',
  ],
  '🍩': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff52294911a_pUZRc8G4dn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F99bed1044b_40fe0HGooP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c12c4836c_yYPtIE2uk5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6b42333707_fyXhdonvAf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc6b0c2ddb_kdtgOEY6zg.gif',
  ],
  '🍬': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7ad4e836fc_rjiBknrWHz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc9ea4cdfd9_lUo0s9EGTY.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7a7d9984ef_ZB7HJDstGH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc0a974eeb5_Gen4QI2bOw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7a28cb74b0_pHjbmo27BL.gif',
  ],
  '👨‍🍳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff83eba3f8e_JNzlwb4qLp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F953d5101bd_cfFmRGz7fd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5435ce84ca_NYhxucwhEn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd7d9dc3275_v08jvvhSzj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fba0ccc26a0_TuEJKMDHAC.gif',
  ],
  '📢': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd784eabee9_YBPbcRTOtP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb8af09b029_R5J0ieohHw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F693df1e86e_o4HBCdtYLi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb86ac83bea_2sSF1SDW5x.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F501fdbe8ca_fL4bZCTjry.gif',
  ],
  '🚕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa891ec6ca9_5L40TpRCqF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F562f3ecf52_leaVgbo1ht.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa8d6de660f_YrSrRkYxK9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd92a59a325_1K8hIkWcAQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3a75421f43_W30Vf165dR.gif',
  ],
  '🏴‍☠️': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fde0afba9f5_yUC0xTwt8e.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59edb9a99e_m5eLvUX1ep.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F813dc13aa1_ilecQo1M5f.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2dddcb58a3_QYgYCbI4WH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2a5d003d91_blvAHWNTVX.gif',
  ],
  '🎈': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbe64158c96_G5hrWifq9h.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffcb7d46bf9_moKIBDeNIL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa48e4f0f16_mDFPqHAEaA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F39a2b588ab_lcUkwYVb8W.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcf3b758115_4ZyeiPudvs.gif',
  ],
  '🦸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F27e7e2b335_LqjauJ6wJA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F315351616e_e8jHTCjf4u.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5902847e53_jVHoyQvYck.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F82f039ad30_GWsQujKja4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe5b359ca0f_ty6JgDBJpD.gif',
  ],
  '🍷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9c23159db6_SF2GbZ2Ero.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F51b3320250_VSTwrWDyWe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd565485b76_Bs6QQ5vfaQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2a204c61be_NS2DEQ1AU2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F68dcfb5887_fpl5f7knz0.gif',
  ],
  '🧟': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd25ca6cd2d_FEqCRGTdfz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7b3f781804_dIKdkdPCyX.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe67f89b1e3_ZpFOKMlNCD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9da7049643_XWxQ46AVwD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faabaec49ac_c56N284jPC.gif',
  ],
  '💸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F51bc4c9dda_IvY3KmUisg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c489582fe_c30z84yjLq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0e78f8a39a_9lNMJFMBjt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5f10956ad5_fSu8Px2wyh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F91c8db011f_LD1U4KTZzg.gif',
  ],
  '🍸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F574397c654aa73513e6bea808c7b082a_4obW4dxZgI_QALWGMZDFC_y2xXEsvGON_19.png',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb703e31298_kWpkm9BaC1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7614e0672e_ZgShJD8OHl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F030a230dda_nrmgeALsTG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe6ec46e6e6_gK3M32Kph4.gif',
  ],
  '🦐': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F36d4208b20_sFELzRclbo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc5b8480baa_XH2hUDmIOf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6655254dc5_5Ym6IQ9ATA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56ddbd3408_CfYfrCnOyD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F53f56ab43c_U2v9KY6YvU.gif',
  ],
  '🗯': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F64e6a5a766_PEg1kCNhvG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0a8b056fea_7IM4SCAEif.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F951ab3f807_p7tqQ1ZfVo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff11ae3d77c_qgokN5n2JL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F04274b8c13_kFgqLC5xxn.gif',
  ],
  '📸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F69ba8cb41b_6APdrTs1kR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F72bbde6aa1_wcjJsRYywx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd30f11520b_KPYIkSiB6p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9b994c7298_P535T5IREU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fec26307145_46RAKxFvHa.gif',
  ],
  '🤙': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa563aa860a_wW9wWSwI2z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F053f040ba8_LxLXKEG1kF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff3862bfbfd_CTsFpeurTp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5f1eb9017c_ADC6dH5fdy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2b1120ef80_F2iqhM7QKL.gif',
  ],
  '🐟': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff3cd217e4e_zDdeHy50v8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fae7fda57ec_D5xdi3Y2G9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc1a62389d1_DdXMxDE611.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7e30ac95f8_V92q3hpFmb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffd6271b98c_IyeG2k7wJA.gif',
  ],
  '🍰': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F67d68664a2_RxPgVhFfve.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F265cd7c1b5_xZEWRQj447.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff625b40319_RY1ZOOVFpr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8e04782bce_oVoCBQmV5E.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F49f603a522_pGfol9Oupy.gif',
  ],
  '🚌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fda2c9dde5e_mEnHP8MqDe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F077c7c2b29_QORoBtA3Yz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9814433f21_nTKaYCYKnK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56efa4fea7_SH39QONyZ2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8b67216473_iEAnl5IYiG.gif',
  ],
  '💄': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff8075700d_7MNvFFkSFD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F297c8a6c95_DsLmXIf2hb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3fce3f9944_BVP40sfR4O.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F908b6ed230_0ptminMlIC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F04eb8783f2_C20wlHVxuc.gif',
  ],
  '🍳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Facc6312866_vHqe8C1Ws2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa584257357_jgygKrCBkF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb462b65129_TDfVjAPWIx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7d29b50598_sCCdZoITRy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1a3b6568fa_GA7jaRqLDC.gif',
  ],
  '💪': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff8dec27a0a_DE5E3HcVY5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feaaffa1f81_PDXFoOxERe.gif',
    'https://img-i.mojitok.com/emoticons/w300/ab30c7c5ef_7CaJ6wDxlQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7eca146446_icRNdJ6H4r.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1bbe44115c_z1VMiZUcBK.gif',
  ],
  '⏰': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1a1e541014_hOJEh2VE1Y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdcd7a80e4d_oMhLbPrsCl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F73b375389c_kimTAGRYGO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe0b7524836_tlsFymmjAg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3de823a372_7CP36Pc7p3.gif',
  ],
  '🚉': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1e6c788b9f_ZI2SRwuMcf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3065ac595e_9E5h207Fh3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F20209268a9_b1uDDj0pIa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcf93018cd1_cLFC9HzSkU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7892aa9cde_pADVCTOKY4.gif',
  ],
  '🌕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F149b503338_wpnS6Daucy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F02aa6d4da8_Wroo2FQJJI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdb1a5f481b_mv7DnDzbJ4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fedcd651d90_MgD57qWHim.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbeae021dbd_XADq83bfJs.gif',
  ],
  '👑': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F52bddc467d_7Y9AUMGjuB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa901b10d07_6XJpNgFEbG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3edcdfbaed_2gxitW0yj1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F74139a687d_bLRJiQAybk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6e9c1fb981_auE3vYDqyC.gif',
  ],
  '🍫': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5c3ada00d3_vzV3wRhDbZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa6fb3bea36_eLdnKP7MRg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F07e35106fb_u3Wu2cebjS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F92d40ef06f_QzDtQFPwsr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F70f7fbddb1_V2ybKiFvEC.gif',
  ],
  '🎸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5d8a0e486b_wtnoUzKQCP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4409fcfa11_xsNXBMnGSi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F28e014eecf_LGOsh8rGN4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F62eafa9b86_gxZj3UvvXj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff183a051a0_ciFvTlt7d4.gif',
  ],
  '💯': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa36dde60cd_fawjcCqaGp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9f7226dc8b_1zYMsd0WN7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8428a81540_N3KHV6BbN7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4ea08ba692_vI1NNrcYx2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcd73338aab_NlmyYQEFCE.gif',
  ],
  '💇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdd3c4ae10f_xFJVOtg7Tj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff4dedbdc06_vIfqsd23zZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa5b89348c4_WWg0HpCMCn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc55aa3a87a_eZ3AiVkFAq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F32ffdb75de8f111c1d3057bfd0aa3b21_S9LDYBgnsL_xSPdQ0s3zM_0weYCjJgxm_%EA%BD%83%EB%8B%A8%EC%9E%A5-2.gif',
  ],
  '☂': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0b6721841a_HMuXUyHXPp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8b7760a807_KR3k4DJvsP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2095dd910b_53c7YmElWE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff447e48230_QU7HN1aqPD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9b7a0fb276_15kk24I3hO.gif',
  ],
  '🌃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F149b503338_wpnS6Daucy.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F02aa6d4da8_Wroo2FQJJI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcefe3262df_yG7U5WgQT3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2c82d4addf_x3P7x6VwDB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd5afca70f8_UOEY2PhsKK.gif',
  ],
  '🧸': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7702dc8769_hhVxVwl0ci.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc5ae9cd57f_2AjWZ18mWM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf769635b8_FsjGBZztlM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f7f0e5fa7_uDZxc0gGaS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb595d56a73_kKFD9SELNh.gif',
  ],
  '🚴': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F91d5934e72_mM3s96jR1P.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F32c6b463aa_s9jYHBD91w.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff6168871f7_m3xEonckWS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6eee6edb82_amqReTn0PH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6ec11c1a3d_xnJrLRa8Eh.gif',
  ],
  '🧝': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5619a24b51_izYZ00coP8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5a1533b161_oW2CGKNXjc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F86f9424f15_7NA1xF9k1a.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F998bfc5dc6_tK9e8BoGOV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59fdf64ddd_1QBQOYFj5r.gif',
  ],
  '🍉': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0beec74489_3PF3lduzVg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ffcfc704bdd_DyU67UgGhL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcd3efca7b7_UPpm5zdNmT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F16c99b1d78_o7TbvhpWS3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6f3f21c6e5_LReDHUiuVt.gif',
  ],
  '👨‍⚕️': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8d0d719f2f_LmZNvIBbT9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F813865da32_7Hbrv2puep.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F70a235d701_olmdqzS2Pc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fde14c378bf_aGpbhR6If5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdcc0d36a7c_Z8yITQUqP5.gif',
  ],
  '🎳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6258e0c0e1_krJppHdOFs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa81ed204ff_0uCo3pVNdA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9fd39c7b71_NexWicU6J3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3cdf374ace_JXkhuQd9cK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F872b74eff8_wvkTLC49fm.gif',
  ],
  '🥭': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fca388c93cf_8S0RbmfCdB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9bb7207c21_83bWaoLjtn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1afdb24529_DfQXEV18IF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe10de74baf_vR8h34gVXa.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb666ab1173_iFkHyQATJg.gif',
  ],
  '🍚': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5b30254d66_aDoYVdOR2G.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F86834c55f4_6Uohe0yxOx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbb5c24abd0_DXJEHSYpZC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F27756254a5_2OZmxG4z6V.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F93b88216aa_430QCUWYXL.gif',
  ],
  '💥': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fffa44edc0e_UCIHZleC9S.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8bf5eb97fa_wNeLsCJn0Z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4275ad6437_c4EcNYXKjc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F76cfe3c9fb_IGZAMGDJCW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F18548068ee_FQnIAGRvIP.gif',
  ],
  '♨': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F789c420c28_aRgxDbLepe.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F297579e428_tTrwOEYABN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F17134fda27_OJaIfrF6DN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fada0506a3f_ydX57BZsP7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8e5aab8395_qklAUNTiTe.gif',
  ],
  '🏕': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcadd614a1a_3DelM7YLbC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F692c108519_HUhGp3EtCG.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F110f24e95a_qR2xrh0J9S.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6e889e3af4_2NQPnIANne.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F06d9d16bb2_p54puBIAmw.gif',
  ],
  '🍍': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F51ba780a39_NlyrKdwSNZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc98c4cf01_XHfo36mre6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F84e0e55177_GwLvN6z4l4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe66d262885_fmA3EKLDF2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F629ccc2b3a_51N6DHrjwP.gif',
  ],
  '🌩': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc055cd6891_XxoDMSJDMK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F944dfa2fcf_ZlbEsU54lp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6b661b57dd_K3bJu9VR1w.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F080a0bac9d_HwkYvAVVgz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fadd5481328_jXEN10sZ6Q.gif',
  ],
  '💼': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3e914116a1_T6JlU4hQHq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F95ec3c3e77_DMXMXeMoge.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb7dfea4101_EXbiTC1g8D.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F94655e1bc2_pcd964qqVd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F35a713a1b5_thO5tOk24K.gif',
  ],
  '🤮': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdf01c693e7334a482a877f83871a687f_uIU6maCye6_IWkaNViTkx_DGHPSA19DP_3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F399e04805f_Mvu1hDO7Jx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb8a522e4cc_gHN35QNrCH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff29e803cdd_fYIA7ubPUD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff689d76a69_DE8MC9s0J4.gif',
  ],
  '🕛': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F81483b54b5_mXWhLghdky.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cbe431fe2_HjyZTfZzTu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F10038d7011_NPliRMqLah.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff6a289a77b_xQPAVYxHfx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc7b576b6e9_tGMDd2YxjG.gif',
  ],
  '🧀': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0a84312646_1FCRJEScNZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdd93693236_mbWevsK9fk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c129eccab_cl1UaT9qwc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F19c5dbc3f1_EdM0lB0Cxr.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5be7283981_xjxJtJxLAZ.gif',
  ],
  '🍔': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa3006b0820_IroMk0XgeV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff35f33e7ed_dw7pb5B6s5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1b034967ac_rJxUdWTESH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F040f8e8d4c_nK2A0cwEVL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F92a9402b84_DGT20BAejx.gif',
  ],
  '🚪': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F83dbf22b1d_pjXmIMbHAz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0f74f267d9_PfLluKa0IE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fed7d7d472a_PMp5OcZ07b.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d2a486106_qXjeZERiQx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feb7c475803_tJmwA8CEOk.gif',
  ],
  '🌮': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59d3167c9e_BniHCH7kDM.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F20e4b0d52a_XgftCMlrmj.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1c63463b89_teZjFn51Dl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe6897f934e_kk0Idca8YL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F340fcd6461_wH3VFHULIX.gif',
  ],
  '🧻': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F331b34ba70_agkUXHNdl3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2351c78993_wtZ0AJ9Bzf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fba63d50bbd_qsppTKXEIC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4eba19194a_fzQAkMcNsQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5030e2cd4f_0rPtDoVFa7.gif',
  ],
  '🤖': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6851c9bcd3_wLFGKqELwp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb782f02864_xfw6iwAgSu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5d0ec20d73_clVsNuCB0y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F425d7b22ea_0eJC46dwqP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F16aa3ed5a3_B9ptDJ8zlC.gif',
  ],
  '🏂': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf24c9a217_IqzOJMCdsc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F49fb5fb7c3_1vuz4MJpaQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F43b0e78e26_JjKaWYoHcv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd90266d6d0_6GUg3JePQ9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff2f53e93ea_1dQMaFrc7F.gif',
  ],
  '🍎': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F79ed782632_RwYMdMBVEB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff5ea42793d_Xixg2ao0Al.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2a2082691e_552XGGkWOW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc697851b05_5lQ9ksoaqd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F946c7d6dc5_ZWBw1iarl7.gif',
  ],
  '🍪': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feca87e23a9_LXLjSf6R6L.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc3148bd275_dj4sA9DHt4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb0d3143f64_Q9ze2s9ijH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8e5fc856af_Usedsyr7M2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3485611cb8_sEfXD8IZkW.gif',
  ],
  '🌇': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0f275a88a1_oJX19kMBOV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F06df97f0bb_bH2vMg1lkt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F73a68213b0_z7q5HwQ0QA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feace8c3fee_oXJnH9skSU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F412e458435_eGtokeyXZ1.gif',
  ],
  '🦁': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe0e2ffaee6_FB0y3GQsPw.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa54f4c58ce_Rdg6BcdOc6.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F94a4024916_XQbsAjQE6m.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4c44c409de_pWYkTmCtx8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcea28b2c95_UvelHhimXF.gif',
  ],
  '🍿': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F444ec5b5df_W5SOllvCrg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F37954595d7_g7QluzJb5z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa5faae83f4_7jvGq4767I.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faae5c56995_QM7ODSLq4W.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5fb38aee72_SP7FEPxnPb.gif',
  ],
  '✏': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb3e2352607_cuHMgOAuu9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F98de8fe569_4A3p77h3jL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc587e69122_uyNb22za1G.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7bff00928d_wWvHGLoJJR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F59bc471b08_BvBCYEtNTs.gif',
  ],
  '🛋': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fefe1c671301dc1b13282712ed44b225d_Vd5y1PcJbZ_Ftgwvsqtk3_aPFKXBGG8s_%EC%8A%A4%ED%85%90%EB%93%9C.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F392675e944_mx7DVhKIeQ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56247f029b_K4R7PMKb5l.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fadb5c9810a_bLcp9NhC5k.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe0a41bdac9_dkXd7BwXAf.gif',
  ],
  '🎟': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe9a83f668e_FunUuPsEcE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe4905b0d04_gmpsvOUdLW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc12716422e_b7Pi1rmwpb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F338497feab_R6cshmTLDL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb33255bc1b_HCJ88jk95Z.gif',
  ],
  '🍣': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff738c4dc37_zEsddWyoEn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf1306d4a2_8HyxX6Cscv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6655254dc5_5Ym6IQ9ATA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Feb6ada6c1e_4RyslQuif8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F56ddbd3408_CfYfrCnOyD.gif',
  ],
  '🎤': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2dcae10dc6_UGIb12w8GU.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3b9210d146_6ZvJwdGjSZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F24363e8d66_Fs1OCYmpI4.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F88ca56cef7_jPHKiZ0GCx.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1d9dc698f0_QQKWrgelZX.gif',
  ],
  '👨‍🎤': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2f10bf6874_edAqnI2452.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb8300578fe_qsnzb2xeDh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd8619d196d_aHX7kKSpyd.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc15c4e09f1_kqRql1rTDn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F615d66e0f2_Et4uBQu3Fw.gif',
  ],
  '🛷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbac381400b_EnLRIQBhgL.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc51fd7061e_FEA0B7xgfV.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff01ad0ff38_IssdBIEBfl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faff18bf2c0_nS4exLyNM3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F39ba7455f5_srqXg1fIzm.gif',
  ],
  '🎮': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F142425d838_O0hhlMGZs3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb372c4ea55_5Q6CAnLdIO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Febe0548e2e_imF4GZL7Bz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7b5d7de847_YO9rGIKYwP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F593193bab7_THrYvqxpiH.gif',
  ],
  '🍝': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6301608a5a_RErE3XQEJg.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe54ad0e425_eA2ZQhNH6P.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faf0a9deecd_Z4S0Pp6Vp0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc9bae1cd33_DWZ50cIUTW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F622924bc45_owFeYyT4jN.gif',
  ],
  '🏬': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fec64105c75_zOlKi7Fq2U.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2266c61e59_mATK8BsLBR.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F287ab40273_9cV7XZIX3V.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2315fd7bb1_b50aV5v1tI.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F221bc429d3_JD45iTsCDG.gif',
  ],
  '👨‍🏭': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faf833f973b_ZYH86XcmMb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F22cb7673d0_08WIOgJWol.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc4f53f548_yULKVdhvfK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F247c29c8bc_0QZfTDXAKH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F421c4b8309_5zJa7KOXTy.gif',
  ],
  '🍟': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F391725732f_3hjzrAA3NW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3cdd1da24e_fxl9wjghXc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F197031774fb30dd7db57f57dc8ec0940_hXVZl6w2QK_2SQzYtFYRv_Wo2p9168Dx_ff.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1b034967ac_rJxUdWTESH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F02c85ccddb_QrSQasR5Sn.gif',
  ],
  '🍓': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0b493b1896_e1RWCkEtzc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F14fe10fd7c_8YpOdZkgBv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff1fdb30465_kp1GHFAZSh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fded28b4624_sgXbMIVJ1Z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5fa7db32d5d24c114d86a558a662d268_FpwNROrfUq_SxYlWT8E05_ARxBg5RDUK_strawberry.gif',
  ],
  '🤥': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa1af13ae5d_EsVnMB9azC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F24f8a38032_FWZq7ZEV3V.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa877e7dc4e_sPPuPu1H1i.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F23a9860289_bih7IMdDGC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fea5df29e51_NMCuP2NBTe.gif',
  ],
  '🏌': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4dea5099c3_pblktMamyC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fff8a0166fb_bn51cyZqR3.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F93bf34190e_TITHeVeHLF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff4fee8f459_cK96UdUqH8.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbb40fbbecf_VEFN5KgQo2.gif',
  ],
  '👨‍🔧': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0b804f5994_bq5kzIyvFm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1aad62ca41_YNBdxdhg18.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc4f53f548_yULKVdhvfK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fae24a9a3d0_koBZ1woSvb.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F843351f176_AU7EHkuiBY.gif',
  ],
  '🤏': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7af887fa97_CaGkt6Rly1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbf55fd8054_DTTomg9KON.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd4a0019700_8JLv5QDZYT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faceb19bb5d_sLQ1HlYF0M.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3d26fe8468_1FbVQ4xZZH.gif',
  ],
  '🌯': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3080441733_kfwAahMr82.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe3b1b043ad_5mRxhPIMVi.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbd047f6f9f_aRBc0O6g1c.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb8a2b5f1e7_b9uHOpmSFA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd7ef2dac87_LY9w3BuDsu.gif',
  ],
  '🆘': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fefb0c9b9fd_tzPNEIjfNz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdc362d827f_bMg7W7wTAT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc45db0334f_uFCAZn8j5k.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5b3fd34521_EIolkKyc2c.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0abb676326_YzRP7f9dCl.gif',
  ],
  '⚾': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1f1314a601_Bw06dJWX8y.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F875e176f73_CvnE6JGBtB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Facc6b85560_wfq1Sn1czu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fcb47b5a55f_QspdE5nCoZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3c421ff45e_FYtrQEB8jx.gif',
  ],
  '💳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2a662781a5_YNOg98i7Ep.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc6b163caec_IBFqZq4CrB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2463430ec1_POrsARVCLv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb7ba526092_NCKTVjN1DE.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0a8569a14a_Ni1T8fxpSy.gif',
  ],
  '⚠': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fefb0c9b9fd_tzPNEIjfNz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe3c931b099_VefDZ4N5kW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd81610e8e1_XLpXSXypaK.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F89a414a5e5_FGqMEaraQm.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc26c524adc_1Mg0JVdcSC.gif',
  ],
  '🥊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2cf7313490_u5EBWs0BGf.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F820c45ff80_Z013QU68YO.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fdbc7bca480_G04mixAe5B.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F76cfe3c9fb_IGZAMGDJCW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5d47aa7430_zvKA8qJkAA.gif',
  ],
  '🔫': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa164e89a5b_wk0OyFpzld.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F61912f5d87_KuaqyDduVq.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F4275ad6437_c4EcNYXKjc.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F3ef616cdca_SeJLbmHew1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F290ac46d95_C0Hj4POgGF.gif',
  ],
  '📷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7c1a9a875b_ljtAEyHC4G.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fa9dd02a320_UH0Mb5GDaN.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd30f11520b_KPYIkSiB6p.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd85e06ddfe_IjARZxmoeB.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F69ba8cb41b_6APdrTs1kR.gif',
  ],
  '🚿': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F20cfdbf26b_3CSFHVJuyH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7015ab2b14_OPrl4SpuFo.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9f05a6e55a_RUrozdkWzn.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F520a08ccc6_W58nCFMakW.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb2990cbc35_pvO7tlvLoL.gif',
  ],
  '🥴': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F353d315cb7_leJWH1yLf5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F2a6ed6a59c_qle90ag6p9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F72e1de540c_tnCftlsPtF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F560d39b17a_EXtNPYcn53.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd9d2ef18dd_abLbeEVrC0.gif',
  ],
  '🍲': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fe4287b604c_LZ14fdEEcz.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F272839d621_RdvLwfNjPv.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9d5be3f028_obCGnQxZy0.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F923381a253_QDGTMfMNkh.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F903d3f0775_amrvZgynw3.gif',
  ],
  '🥪': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd9f4928296_eRu7zlhsCk.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb8a2b5f1e7_b9uHOpmSFA.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fc16bf63b18_dJYdBD01F9.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F329a12ab82_CJyxYdZKHt.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7c487b5479_7Wu17jWOEA.gif',
  ],
  '🏳': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8be781d4f5_ZxjjFFXUi2.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9ee339d615_KiG5DBncPl.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F89ce2d1eba_GFZteaHeXP.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6bc1929b5e_LbHNBQkknu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fb3c753c990_5HvUQ7yxOI.gif',
  ],
  '💊': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9a4915c122_xhRzN1n3RJ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fad8a1a91df_xuRWsnsS0L.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F7bcd317bc7_wXYsjQwJAF.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1fe2d2a87c_eCd8m0T29z.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F6d3d17ad3e_x8AYXqWIUT.gif',
  ],
  '🥔': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0bb513a441_L9Wai37UNv.png',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F64ef3a27e6_VawEkww2Hp.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbe881bca8f_cnAOWMWbf5.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fd570707581_BQNrgMuvvT.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F273b3729fe_BbRL1ULPHK.gif',
  ],
  '🎷': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9ac059f60d_m4OpGKOa5f.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F67995f40cf_bvFkppCHAS.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F132ba0bfe2_W00kc90eSZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F505b2736e6_iycb6FCFYs.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F24a1553d85_8YMrRFM09x.gif',
  ],
  '🏆': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F0c6150bb55_YtxKVGUVKC.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Fbaf4e2512c_i62DikJceu.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F9f7226dc8b_1zYMsd0WN7.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F5f340ce9b5_LzskMV0vr1.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Faa70f27c76_DHkcpv0Fbp.gif',
  ],
  '🙃': [
    'https://img-i.mojitok.com/emoticons%2Fw300%2F45e1be3cc8_tASTGBGcoZ.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F1b14c2de0d_Sf29VDAfDH.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F46ae07d588_WkuHdaxk0R.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2F8d927b8cea_wyp4ONjixD.gif',
    'https://img-i.mojitok.com/emoticons%2Fw300%2Ff32dc1e6a4_VmGu3jk7cQ.gif',
  ],
}
export default obj
